<div class="app-inner-layout">
    <section class="container header-section-website">
        <div class="row">
            <div class="col-8 flex-row d-flex justify-content-start align-items-center">
                <a href="https://www.mobilitateurbana4.ro" class="back-link"><i class="fa-solid fa-angles-left"></i>
                    Înapoi în site</a>
            </div>
            <div class="col-4 flex-row d-flex justify-content-end align-items-center">
                <a href="https://www.mobilitateurbana4.ro">
                    <img src="../../../assets/img/logo-ps4-dmu.png" class="img-fluid" />
                </a>
            </div>
        </div>
    </section>
    <section class="container-fluid header-bg">
        <div class="bg-overlay"></div>
        <div class="row">
            <div class="container">
                <div class="col-sm-12">
                    <h4 style="text-transform: uppercase">MOBILITATE URBANĂ</h4>
                    <br />
                    <h1>Blocări - Deblocări Auto</h1>
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="row">
            <div class="col-12 mt-2 mb-2">
                <h1 class="text-center border-bottom custom-border-color">Plată Tarif Deblocare autovehicul</h1>
            </div>
        </div>
        <!-- <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-file-lines"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Regulament
                </h3>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-12">
                <ul class="custom-list">
                    <li class="list-item">
                        <a href="https://dev.regenerareurbana4.ro/wp-content/uploads/2023/05/REGULAMENT-RIDICARI_-in-vigoare.pdf"
                            target="_blank">

                            <span class="list-item-icon"><i class="fa-solid fa-cloud-arrow-down"></i></span>
                            <span class="list-item-text">REGULAMENT privind procedura de ridicare a
                                autovehiculelor, prevăzută de Regulamentul de aplicare a Ordonanţei de urgenţă a
                                Guvernului nr. 195/2002, aprobat prin Hotărârea Guvernului nr. 1.391/2006, cu
                                modificările şi completările ulterioare, precum și ridicarea vehiculelor prevăzută de
                                Ordonanţa nr. 21/2002 privind gospodărirea localităţilor urbane şi rurale cu
                                modificările şi completările ulterioare, pe străzile și domeniul public aflat în
                                administrarea Sectorului 4 al Municipiului București</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
    <!-- <div class="container">
        <div class="row mb-5 pb-5 mt-5">
            <div class="col-12 divider-line-heading">
                <div>
                    <span class="outer-line"></span>
                    <i class="fa-solid fa-magnifying-glass-location"></i>
                    <span class="outer-line"></span>
                </div>
                <h3 class="manropeFamily">Informații privind Autoturisme ridicate de pe Raza Sectorului 4
                </h3>
            </div>
        </div>
    </div> -->
    <section class="container-fluid header-bg">
        <!-- <div class="bg-overlay"></div> -->
        <!-- <div class="row"> -->
        <div class="container">
            <div class="row d-flex flex-row justify-content-between align-items-center">
                <div class="col-sm-12 col-md-6">
                    <p class="manropeFamily whiteText pb-1 pt-1">
                        Plata cu cardul online poate fi efectuată utilizând numărul autovehiculului dumneavoastră.</p>
                    <p class="manropeFamily whiteText pb-1 pt-1">Pe baza Referinței introduse puteți achita următoarele:
                    </p>
                    <ul class="whiteText">
                        <li>
                            <p class="manropeFamily whiteText mb-0">Art.53. Tarifele pentru deblocarea roții
                                autovehiculului/vehiculului sunt progresive, după cum urmează:</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Art.53. alin(1) Tariful de deblocare este de 300(trei
                                sute) lei TVA inclus.</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Art.53. alin(2) Dacă nu se solicită deblocarea roții
                                în termen de 24(douăzeci și patru) de ore de la blocare, tariful aplicat pentru fiecare
                                zi in care situatia persista va fi de 100(o suta) lei tva inclus.</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">Art.54. (1) Pentru ocuparea abuzivă a unui loc de
                                parcare de reședință sau a unui loc situat într-o parcare publică marcat corespunzător,
                                destinat persoanelor cu dizabilități sau staționarea voluntară fără drept pe locurile
                                prevăzute cu stații de încărcare pentru autoturismele electrice/hibrid ori pe locurile
                                destinate autovehiculelor de tip car sharing, semnalizate corespunzător într-o parcare
                                publică, precum și pentru staționarea voluntară în scop publicitar sau de vânzare a unui
                                autovehicul/vehicul, într-o parcare publică sau de reședință se va lua măsura
                                tehnico-administrativă a ridicării, transportului și depozitării
                                autovehiculului/vehiculului, iar în cazul în care nu se poate interveni cu mijloace de
                                ridicare auto, se va putea lua, de către Operator, măsura tehnico-administrativă a
                                blocării roții autovehiculului/vehiculului, tariful de deblocare de referință fiind de
                                1000(omie) lei/24h, tarif nefracționat.</p>
                        </li>
                        <li>
                            <p class="manropeFamily whiteText mb-0">(2) Dacă nu se solicită deblocarea roții în termen
                                de 24(douăzeci și patru) de ore de la blocare, tariful se va calcula pentru fiecare zi
                                în care persistă situația.</p>
                        </li>


                    </ul>

                    <p class="manropeFamily whiteText pb-1 pt-1">Pentru siguranță, tranzacțiile sunt procesate de către
                        EuPlătesc.ro în numele Direcției pentru MOBILITATE URBANĂ Sector 4, utilizând soluţii anifraudă
                        avansată care duc la diminuare riscurilor asociate tentativelor de fraudă electronică.</p>
                </div>
                <div class="col-sm-12 col-md-6" *ngIf="showSuccess">
                    <h4 class="manropeFamily whiteText">Aveți de plată următoarele:</h4>
                    <br />
                    <p class="manropeFamily whiteText">Număr Auto: <strong>{{formData.value.numar_auto}}</strong></p>
                    <p class="manropeFamily whiteText">Descriere: <strong>{{formResult.tax_name}}</strong></p>
                    <p class="manropeFamily whiteText">Total: <strong>{{formResult.total}} (TVA Inclus)</strong></p>

                    <br />
                    <br />
                    <br />
                    <button type="button" (click)="processPaymentLink()"
                        class="btn-block btn-lg btn btn-outline-warning whiteText">
                        Plătește acum
                    </button>
                    <br />
                    <br />
                    <br />
                    <button type="button" (click)="resetForm()"
                        class="btn-block btn-lg btn btn-outline-warning whiteText">
                        Resetare Verificare
                    </button>
                </div>
                <div class="col-sm-12 col-md-6 whiteText" *ngIf="!showSuccess">
                    <form [formGroup]="formData" (ngSubmit)="checkAuto()">

                        <!-- nume -->
                        <div class="col-sm-12">
                            <div
                                class="form-group d-flex flex-column justify-content-center align-items-start white-text">
                                <label for="numar_auto" class="manropeFamily">Număr Auto <span
                                        class="red-text">*</span></label>
                                <mat-form-field class="custom-input w-100" appearance="outline">
                                    <input formControlName="numar_auto" placeholder="B123ABC.." matInput
                                        [errorStateMatcher]="matcher" type="text" required="required">
                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.required">
                                        <strong>Câmp obligatoriu</strong>
                                    </mat-error>
                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.minlength">
                                        <strong>Minim 3 caractere</strong>
                                    </mat-error>

                                    <mat-error class="p-2"
                                        *ngIf="(numar_auto.dirty || numar_auto.touched) && numar_auto.errors?.maxlength">
                                        <strong>Max 12 caractere</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <div class="form-group">
                                <mat-checkbox formControlName="termeni_conditii" class="mt-5 mb-5 termeni_conditii">
                                    Sunt de acord cu
                                    <a href="https://www.mobilitateurbana4.ro/politica-de-confidentialitate/" target="_blank">termenii și
                                        condițiile de confidențialitate ale Direcției Mobilitate Urbană Sector 4</a>
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="col-12 mt-5">
                            <div class="form-group">
                                <button type="submit" [disabled]="!formData.valid"
                                    class="btn-block btn-lg btn btn-outline-light">
                                    Verificare Auto
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </section>
    <section class="container">
        <div class="row">
            <div
                class="col-12 mt-5 mb-5 d-flex flex-row justify-content-between align-items-center custom-images-flex-logos">
                <div><img src="../../../../assets/img/euplatesc.jpg" class="img-fluid" /></div>
                <div><img src="../../../../assets/img/Mastercard-new-logo.jpg" style="max-width:45%"
                        class="img-fluid" /></div>
                <div><img src="../../../../assets/img/visa.jpg" style="max-width:60%" class="img-fluid" /></div>
                <div><img src="../../../../assets/img/bt-2048x425.jpg" style="max-width:80%" class="img-fluid" /></div>
            </div>
        </div>
    </section>
</div>